import React from "react";
import { TextField as MuiTextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(MuiTextField)<TextFieldProps>(() => ({
  // Add any custom styles here if needed
}));

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return <StyledTextField ref={ref} {...props} />;
  }
);

TextField.displayName = "TextField";

export default TextField;
